<template>
  <div>
    <!-- #region Details section -->
    <el-card class="mx-2">
      <el-descriptions class="margin-top" title="Farm Details" :column="4" border>
        <template slot="extra">
          <el-button size="small" @click="dialogs.seasons = true">Change Season</el-button>
          <el-button size="small" @click="showImages(farm.images)">Show Images</el-button>
          <el-button size="small" @click="showPlotLocation(farm.location_point, farm.plot_marks)">Show Plot
            Location</el-button>
        </template>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-tickets"></i>
            Field ID
          </template>
          {{ farm.farm_id }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-user"></i>
            Farmer
          </template>
          {{ farm.farmer }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-tickets"></i>
            Farmer ID
          </template>
          {{ farm.farmer_id }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-user"></i>
            Assigned To
          </template>
          {{ farm.assigned_to.join() }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-house"></i>
            Acre
          </template>
          {{ farm.acre }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-help"></i>
            Irrigation
          </template>
          {{ farm.irrigation }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-pear"></i>
            Seed Type
          </template>
          {{ farm.seed_type }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-cherry"></i>
            Cultivation Variety
          </template>
          {{ farm.cultivation_variety }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-location-information"></i>
            North
          </template>
          {{ farm.near_by_plots.north }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-location-information"></i>
            South
          </template>
          {{ farm.near_by_plots.south }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-location-information"></i>
            East
          </template>
          {{ farm.near_by_plots.east }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-location-information"></i>
            West
          </template>
          {{ farm.near_by_plots.west }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-chat-line-square"></i>
            Remark
          </template>
          {{ farm.remark }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-shopping-bag-2"></i>
            Active year
          </template>
          {{ farm.active_year }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-shopping-bag-2"></i>
            Dealer
          </template>
          {{ farm.dealer }}
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
    <!-- #endregion -->
    <div class="my-5" />
    <!--#region Stages Section  -->
    <el-card class="mx-2">
      <el-table :data="filteredStages" style="width: 100%" border
        :header-cell-style="{ background: '#f1f1f5', color: 'black', textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }">
        <el-table-column type="expand">
          <template slot-scope="props">
            <!-- #region Soil Analysis -->
            <el-descriptions class="margin-top" :column="3" border v-if="props.row.caption === 'Soil Analysis'">
              <el-descriptions-item label="Soil Test Date">
                {{ formatDate(props.row.details.soil_test_date) }}
              </el-descriptions-item>
              <el-descriptions-item label="Soil Type">
                {{ props.row.details.soil_type }}
              </el-descriptions-item>
              <el-descriptions-item label="Previous Cultivation">
                {{ props.row.details.previous_cultivation }}
              </el-descriptions-item>
              <el-descriptions-item label="Remark">
                {{ props.row.remarks }}
              </el-descriptions-item>
              <el-descriptions-item label="Result">
                {{ props.row.details.result }}
              </el-descriptions-item>
              <el-descriptions-item label="Actions">
                <el-button size="small" @click="showImages(props.row.images)">Show Images</el-button>
                <el-button size="small" @click="showLocation(props.row.location)">Show Location</el-button>
              </el-descriptions-item>
            </el-descriptions>
            <!-- #endregion -->

            <!-- #region Sowing -->
            <el-descriptions class="margin-top" :column="3" border v-if="props.row.caption === 'Sowing'">
              <el-descriptions-item label="Cultivation Variety">
                {{ props.row.details.cultivation_variety }}
              </el-descriptions-item>
              <el-descriptions-item label="Estimated Harvest">
                {{ props.row.details.estimated_harvest }}
              </el-descriptions-item>
              <el-descriptions-item label="Mode">
                {{ props.row.details.mode }}
              </el-descriptions-item>
              <el-descriptions-item label="Remark">
                {{ props.row.remarks }}
              </el-descriptions-item>
              <el-descriptions-item label="Actions">
                <el-button size="small" @click="showImages(props.row.images)">Show Images</el-button>
                <el-button size="small" @click="showLocation(props.row.location)">Show Location</el-button>
              </el-descriptions-item>
            </el-descriptions>
            <!-- #endregion -->

            <!-- #region Planting -->
            <el-descriptions class="margin-top" :column="3" border v-if="props.row.caption === 'Planting'">
              <el-descriptions-item label="Transplant Date">
                {{ formatDate(props.row.details.transplant_date) }}
              </el-descriptions-item>
              <el-descriptions-item label="Space Between R to R">
                {{ props.row.details.space_btn_r_to_r }}
              </el-descriptions-item>
              <el-descriptions-item label="Space Between P to P">
                {{ props.row.details.space_btn_p_to_p }}
              </el-descriptions-item>
              <el-descriptions-item label="Remark">
                {{ props.row.remarks }}
              </el-descriptions-item>
              <el-descriptions-item label="Actions">
                <el-button size="small" @click="showImages(props.row.images)">Show Images</el-button>
                <el-button size="small" @click="showLocation(props.row.location)">Show Location</el-button>
              </el-descriptions-item>
            </el-descriptions>
            <!-- #endregion -->

            <!-- #region Pesticides -->
            <el-descriptions class="margin-top" :column="3" border v-if="props.row.caption === 'Pesticides'">
              <el-descriptions-item label="Disease Type">
                {{ props.row.details.disease_type }}
              </el-descriptions-item>
              <el-descriptions-item label="Dosage">
                {{ props.row.details.dosage_pesticides }}
              </el-descriptions-item>
              <el-descriptions-item label="Chemical Name">
                {{ props.row.details.chemical_name_pesticides }}
              </el-descriptions-item>
              <el-descriptions-item label="Brand">
                {{ props.row.details.brand }}
              </el-descriptions-item>
              <el-descriptions-item label="Crop Condition">
                {{ props.row.details.crop_condition }}
              </el-descriptions-item>
              <el-descriptions-item label="Next Visit">
                {{ formatDate(props.row.details.next_visit) }}
              </el-descriptions-item>
              <el-descriptions-item label="Remark">
                {{ props.row.remarks }}
              </el-descriptions-item>
              <el-descriptions-item label="Actions">
                <el-button size="small" @click="showImages(props.row.images)">Show Images</el-button>
                <el-button size="small" @click="showLocation(props.row.location)">Show Location</el-button>
              </el-descriptions-item>
            </el-descriptions>
            <!-- #endregion -->

            <!-- #region Fertilizer -->
            <el-descriptions class="margin-top" :column="3" border v-if="props.row.caption === 'Fertilizer'">
              <el-descriptions-item label="Mode Of Application">
                {{ props.row.details.mode_of_application }}
              </el-descriptions-item>
              <el-descriptions-item label="Chemical Name">
                {{ props.row.details.chemical_name_fertilizer }}
              </el-descriptions-item>
              <el-descriptions-item label="NPK Percentage">
                {{ props.row.details.npk_percentage }}
              </el-descriptions-item>
              <el-descriptions-item label="Crop Condition">
                {{ props.row.details.crop_condition }}
              </el-descriptions-item>
              <el-descriptions-item label="Next Visit">
                {{ formatDate(props.row.details.next_visit) }}
              </el-descriptions-item>
              <el-descriptions-item label="Remark">
                {{ props.row.remarks }}
              </el-descriptions-item>
              <el-descriptions-item label="Actions">
                <el-button size="small" @click="showImages(props.row.images)">Show Images</el-button>
                <el-button size="small" @click="showLocation(props.row.location)">Show Location</el-button>
              </el-descriptions-item>
            </el-descriptions>

            <!-- #endregion -->

            <!-- #region Plant Growth Regulator -->
            <el-descriptions class="margin-top" :column="3" border
              v-if="props.row.caption === 'Plant Growth Regulator'">
              <el-descriptions-item label="Chemical Name">
                {{ props.row.details.chemical_name_plant_growth }}
              </el-descriptions-item>
              <el-descriptions-item label="Content">
                {{ props.row.details.content }}
              </el-descriptions-item>
              <el-descriptions-item label="Dosage">
                {{ props.row.details.dosage_plant_growth }}
              </el-descriptions-item>
              <el-descriptions-item label="Crop Condition">
                {{ props.row.details.crop_condition }}
              </el-descriptions-item>
              <el-descriptions-item label="Next Visit">
                {{ formatDate(props.row.details.next_visit) }}
              </el-descriptions-item>
              <el-descriptions-item label="Remark">
                {{ props.row.remarks }}
              </el-descriptions-item>
              <el-descriptions-item label="Actions">
                <el-button size="small" @click="showImages(props.row.images)">Show Images</el-button>
                <el-button size="small" @click="showLocation(props.row.location)">Show Location</el-button>
              </el-descriptions-item>
            </el-descriptions>

            <!-- #endregion -->

            <!-- #region General Visit -->
            <el-descriptions class="margin-top" :column="3" border v-if="props.row.caption === 'General Visit'">
              <el-descriptions-item label="Next Visit">
                {{ formatDate(props.row.details.next_visit) }}
              </el-descriptions-item>
              <el-descriptions-item label="Remark">
                {{ props.row.remarks }}
              </el-descriptions-item>
              <el-descriptions-item label="Actions">
                <el-button size="small" @click="showImages(props.row.images)">Show Images</el-button>
                <el-button size="small" @click="showLocation(props.row.location)">Show Location</el-button>
              </el-descriptions-item>
            </el-descriptions>

            <!-- #endregion -->

            <!-- #region QC Sampling -->
            <el-descriptions class="margin-top" :column="3" border v-if="props.row.caption === 'QC Sampling'">
              <el-descriptions-item label="Sampler">
                {{ props.row.details.sampler_name }}
              </el-descriptions-item>
              <el-descriptions-item label="Expected Overall Yield">
                {{ props.row.details.expected_overall_yield }}
              </el-descriptions-item>
              <el-descriptions-item label="Plucking No">
                {{ props.row.details.plucking_number }}
              </el-descriptions-item>
              <el-descriptions-item label="Plucking Date">
                {{ formatDate(props.row.details.plucking_date) }}
              </el-descriptions-item>
              <el-descriptions-item label="Remark">
                {{ props.row.remarks }}
              </el-descriptions-item>
              <el-descriptions-item label="Actions">
                <el-button size="small" @click="showImages(props.row.images)">Show Images</el-button>
                <el-button size="small" @click="showLocation(props.row.location)">Show Location</el-button>
              </el-descriptions-item>
            </el-descriptions>

            <!-- #endregion -->

            <!-- #region Post Harvest -->
            <el-descriptions class="margin-top" :column="3" border v-if="props.row.caption === 'Post Harvest'">
              <el-descriptions-item label="Lot ID">
                {{ props.row.details.lot_id }}
              </el-descriptions-item>
              <el-descriptions-item label="Color Tag">
                {{ props.row.details.color_tag }}
              </el-descriptions-item>
              <el-descriptions-item label="Final Quantity">
                {{ props.row.details.final_quantity }}
              </el-descriptions-item>
              <el-descriptions-item label="Number Of Bags">
                {{ props.row.details.number_of_bags }}
              </el-descriptions-item>
              <el-descriptions-item label="Medium of Drying">
                {{ props.row.details.medium_of_drying }}
              </el-descriptions-item>
              <el-descriptions-item label="Remark">
                {{ props.row.remarks }}
              </el-descriptions-item>
              <el-descriptions-item label="Actions">
                <el-button size="small" @click="showImages(props.row.images)">Show Images</el-button>
                <el-button size="small" @click="showLocation(props.row.location)">Show Location</el-button>
              </el-descriptions-item>
            </el-descriptions>

            <!-- #endregion -->

            <!-- #region Truck -->
            <el-descriptions class="margin-top" :column="4" border v-if="props.row.caption === 'Truck'">
              <el-descriptions-item label="Lot ID">
                {{ props.row.details.lot_id }}
              </el-descriptions-item>
              <el-descriptions-item label="Truck Number">
                {{ props.row.details.truck_number }}
              </el-descriptions-item>
              <el-descriptions-item label="Driver Name">
                {{ props.row.details.driver_name }}
              </el-descriptions-item>
              <el-descriptions-item label="Driver Mobile">
                {{ props.row.details.driver_mobile }}
              </el-descriptions-item>
              <el-descriptions-item label="Seal No : 1">
                {{ props.row.details.seal_no_1 }}
              </el-descriptions-item>
              <el-descriptions-item label="Seal No : 2">
                {{ props.row.details.seal_no_2 }}
              </el-descriptions-item>
              <el-descriptions-item label="Seal No : 3">
                {{ props.row.details.seal_no_3 }}
              </el-descriptions-item>
              <el-descriptions-item label="Seal No : 4">
                {{ props.row.details.seal_no_4 }}
              </el-descriptions-item>
              <el-descriptions-item label="Seal No : 5">
                {{ props.row.details.seal_no_5 }}
              </el-descriptions-item>
              <el-descriptions-item label="Seal No : 6">
                {{ props.row.details.seal_no_6 }}
              </el-descriptions-item>
              <el-descriptions-item label="Security Pin">
                {{ props.row.details.security_pin }}
              </el-descriptions-item>
              <el-descriptions-item label="Remark">
                {{ props.row.remarks }}
              </el-descriptions-item>
              <el-descriptions-item label="Actions">
                <el-button size="small" @click="showImages(props.row.images)">Show Images</el-button>
                <el-button size="small" @click="showLocation(props.row.location)">Show Location</el-button>
              </el-descriptions-item>
            </el-descriptions>

            <!-- #endregion -->
          </template>
        </el-table-column>
        <el-table-column prop="caption" label="Stage" />
        <el-table-column label="Date">
          <template slot-scope="scope">
            {{ formatDate(scope.row.current_date) }}
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- #endregion -->

    <!-- #region Leaflet Map Dialog component -->
    <el-dialog :visible.sync="dialogs.location">
      <l-map :zoom="18" :center="leafLet.center" :ref="`mymap` + j" style="height:500px; width: 100%">
        <l-tile-layer :url="leafLet.url" />
        <l-marker :lat-lng="leafLet.marker_lat_lang">
          <l-tooltip :options="{
            permanent: true,
            interactive: true,
          }">
            <div>Updated Location</div>
          </l-tooltip>
        </l-marker>
        <l-icon-default :image-path="iconUrl" />
        <l-polygon :lat-lngs="leafLet.polygon_lat_lang" color="red">
          <l-popup content="Plot" />
        </l-polygon>
      </l-map>
    </el-dialog>

    <!-- #endregion -->

    <!-- #region Season Selection Modal -->
    <el-dialog :visible.sync="dialogs.seasons">
      <el-select v-model="seasons.selected" clearable placeholder="Select season" size="large" value-key="id">
        <el-option v-for="item in seasons.items" :key="item.id" :label="item.label" :value="item">
          <span style="float: left">{{ item.label }}</span>
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogs.seasons = false">Cancel</el-button>
        <el-button type="primary" @click="getFarmDetails_stages(farm.farm_id, seasons.selected.id)">Confirm</el-button>
      </span>
    </el-dialog>

    <!-- #endregion -->
  </div>
</template>

<script>
import axios from "axios";
import LoaderService from "../../utils/LoaderService";
import { getImage, LeafLetConfig } from "../../utils/utils";
import { api as viewerApi } from "v-viewer";
import { AlertService } from "../../utils/AlertService";
import { latLng } from "leaflet";

export default {
  name: "FarmDetails",
  computed: {
    filteredStages() {
      if (!this.isMounted) return;
      return this.stages.filter((stage) => stage.caption !== "Farmer" && stage.caption !== "Farm");
    },
  },
  data() {
    return {
      farm: {
        farm_id: "",
        farmer: "",
        farmer_id: "",
        acre: 0,
        images: [],
        irrigation: "",
        location_points: null,
        near_by_plots: null,
        plot_marks: null,
        remarks: "",
        seed_type: "",
      },
      stages: [],
      leafLet: {
        url: LeafLetConfig.url,
        attribution: LeafLetConfig.attribution,
        center: null,
        marker_lat_lang: null,
        polygon_lat_lang: null,
      },
      seasons: {
        items: [],
        selected: null,
      },
      dialogs: {
        location: false,
        seasons: false,
      },
      isMounted: false,
    };
  },
  methods: {
    async onInit() {
      await this.getAllSeasons();
    },
    getImage: getImage,
    formatDate(date) {
      let monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      //  month = "" + (d.getMonth() + 1),
      var d = new Date(date),
        month = "" + monthNames[d.getMonth()],
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      // var d = dateVar.add(-1).day().toString('dd-MMM-yyyy');

      return [day, month, year].join(" - ");
    },
    async getFarmDetails_stages(farm_id, active_year_id) {
      const urls = [
        `/farm/v2/details/${farm_id}/?active_year_id=${active_year_id}`,
        `/farm/crop-stage-by-farm/${farm_id}/?active_year_id=${active_year_id}`,
      ];

      Promise.all(urls.map((url) => axios.get(url)))
        .then((res) => {
          if (!res[0].data) {
            AlertService.error("Farm was not active in the selected Season");
            this.$router.go(-1);
            return;
          }

          this.farm = res[0].data;
          this.stages = res[1].data;
          this.dialogs.seasons = false;
        })
        .catch((err) => console.log(err))
        .finally(() => {
          LoaderService.closeLoader();
        });
    },
    async getAllSeasons() {
      axios
        .get(`/active-year?sort=id%2CASC`)
        .then(async (res) => {
          console.log(res.data.filter((season) => season.active_status == true));
          this.seasons.items = res.data;
          const farm_id = this.$route.params.farm_id || localStorage.getItem("farm_id");
          this.seasons.selected = res.data.filter((season) => season.active_status == true)[0];
          await this.getFarmDetails_stages(farm_id, this.seasons.selected.id);
        })
        .catch((err) => console.log(err))
        .finally(() => LoaderService.closeLoader());
    },
    getImageLinks(images) {
      return images.map((image) => {
        return getImage(image);
      });
    },
    showImages(images) {
      if (!images) {
        AlertService.error(`No Images Found!`);
        return;
      }

      let imagesLinks = [];
      // Checking if the images are object array or not
      if (typeof images[0]["label"] !== "undefined") {
        imagesLinks = this.getImageLinks(images.map((image) => image.label));
      } else {
        imagesLinks = this.getImageLinks(images);
      }

      const $viewer = viewerApi({
        images: imagesLinks,
      });
      $viewer.show();
    },
    showLocation(location) {
      console.log(location);
      this.leafLet.marker_lat_lang = this.getLocation(location);
      this.leafLet.center = this.getMapCenter(location);
      this.dialogs.location = true;
    },
    showPlotLocation(location, plot_marks) {
      console.log(location);

      this.leafLet.marker_lat_lang = this.getLocation(location);
      this.leafLet.center = this.getMapCenter(location);
      this.leafLet.polygon_lat_lang = this.getPolygonLocations(plot_marks);
      this.dialogs.location = true;
    },
    getLocation(loc) {
      return latLng(loc.lat, loc.long);
    },
    getMapCenter(loc) {
      return [loc.lat, loc.long];
    },
    getPolygonLocations(plot_marks) {
      let arr = [];
      plot_marks.forEach((element) => {
        arr.push([element.lat, element.long]);
      });
      return arr;
    },
  },
  async created() {
    // Check if farm_id exists in route params or localStorage, otherwise go back
    const farm_id = this.$route.params.farm_id || localStorage.getItem("farm_id");
    if (!farm_id) {
      this.$router.go(-1);
    }
    // Save the farm_id in localStorage for future reloads
    localStorage.setItem("farm_id", farm_id);
    await this.onInit();
    this.isMounted = true;
  },
  beforeDestroy() {
    // Clear the farm_id from localStorage
    localStorage.removeItem("farm_id");
  },
};
</script>
